module.exports = __webpack_public_path__ + "static/media/sh-hl.314b5ca1.svg";